import React from 'react';

const AdvocateFiltersSection = ({
  appliedRange,
  buildRangeLabel,
  error,
  form,
  loading,
  onApply,
  rows,
  setForm,
  today,
  topOptions,
}) => {
  return (
    <div className="perf-section">
      <div className="perf-section-head">
        <h4>Advocate Filters</h4>
        <span className="perf-pill">{buildRangeLabel(appliedRange.from, appliedRange.to)}</span>
      </div>

      <div className="perf-filters">
        <label>
          <span>Date From</span>
          <input
            type="date"
            value={form.dateFrom}
            max={today}
            onChange={(e) => setForm((prev) => ({ ...prev, dateFrom: e.target.value }))}
          />
        </label>
        <label>
          <span>Date To</span>
          <input
            type="date"
            value={form.dateTo}
            max={today}
            onChange={(e) => setForm((prev) => ({ ...prev, dateTo: e.target.value }))}
          />
        </label>
        <label>
          <span>Lawyer</span>
          <select
            value={form.lawyerId}
            onChange={(e) => setForm((prev) => ({ ...prev, lawyerId: e.target.value }))}
          >
            <option value="all">All Lawyers</option>
            {rows.map((row) => (
              <option key={row.id} value={row.id}>{row.name}</option>
            ))}
          </select>
        </label>
        <label>
          <span>Top Count</span>
          <select
            value={form.topN}
            onChange={(e) => setForm((prev) => ({ ...prev, topN: e.target.value }))}
          >
            {topOptions.map((count) => (
              <option key={count} value={count}>{`Top ${count}`}</option>
            ))}
          </select>
        </label>
        <button
          className="btn btn-soft"
          type="button"
          onClick={() => setForm((prev) => ({ ...prev, dateFrom: today, dateTo: today }))}
        >
          Today
        </button>
        <button className="btn btn-primary" type="button" onClick={onApply} disabled={loading}>
          {loading ? 'Loading...' : 'Apply'}
        </button>
      </div>

      {error ? <div className="perf-empty">{error}</div> : null}

      {/* Advocate summary panel disabled temporarily.
          To enable again, uncomment the block below.
      {!error ? (
        <div className="perf-wide-row">
          <article className="perf-card">
            <div className="perf-card-head">
              <span>{displayedLawyerLabel}</span>
              <span className="perf-pill">Query Count</span>
            </div>
            <div className="perf-metric">{formatCount(displayedLawyerCount, true)}</div>
            <div className="perf-sub">{`Top ${appliedRange.topN} for ${buildRangeLabel(appliedRange.from, appliedRange.to)}`}</div>
            <div className="perf-mini-grid">
              <div>
                <span>Selected Range</span>
                <strong>{buildRangeLabel(appliedRange.from, appliedRange.to)}</strong>
              </div>
              <div>
                <span>Loaded Lawyers</span>
                <strong>{rows.length}</strong>
              </div>
            </div>
          </article>

          <article className="perf-card">
            <div className="perf-card-head">
              <span>User Wise Query Count</span>
              <span className="perf-pill">{`Top ${appliedRange.topN}`}</span>
            </div>
            <div className="perf-range-list">
              {rows.length ? (
                rows.map((row) => (
                  <button
                    key={row.id}
                    className={`perf-range-item ${row.id === form.lawyerId ? 'active' : ''}`}
                    type="button"
                    onClick={() => setForm((prev) => ({ ...prev, lawyerId: row.id }))}
                  >
                    <span>{row.name}</span>
                    <strong>{formatCount(row.total)}</strong>
                    <em>{buildRangeLabel(appliedRange.from, appliedRange.to)}</em>
                  </button>
                ))
              ) : (
                <div className="perf-empty">No records found for selected range.</div>
              )}
            </div>
          </article>
        </div>
      ) : null}
      */}
    </div>
  );
};

export default AdvocateFiltersSection;
